import { appPath } from './appPath';

export function platformBasePath() {
  return (process.env.REACT_APP_PLATFORM_ADMIN_PREFIX || '/platform').replace(/\/$/, '');
}

export function companyBasePath() {
  return (process.env.REACT_APP_COMPANY_ADMIN_PREFIX || '/company').replace(/\/$/, '');
}

export function platformUrl(segment) {
  const s = String(segment || '').replace(/^\//, '');
  return appPath(`${platformBasePath()}/${s}`);
}

export function companyUrl(segment) {
  const s = String(segment || '').replace(/^\//, '');
  return appPath(`${companyBasePath()}/${s}`);
}
